<template>
    <div class="bg-white shadow-small flex items-center text-neutral-800 mb-1 pr-2 overflow-hidden rounded-xl">
        <button @click="$emit('back')" class="button-transparent rounded-r-none w-11 p-1.5 mr-2 shrink-0 self-stretch" :title="$t('global.Back')">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></svg>
        </button>

        <div v-if="type == 'institution' && item.iconHtml" v-html="item.iconHtml" class="h-[34px] w-[36px] px-px mr-3 shrink-0"></div>

        <div v-else-if="type == 'specialist'" class="border border-secondary/80 text-secondary/80 h-9 w-9 rounded-full overflow-hidden mr-3 shrink-0">
            <specialist-image
                :url="item.icon"
                :gender="item.gender"
            />
        </div>

        <div v-if="type == 'timeslot'" class="flex flex-wrap items-center py-1.5 grow">
            <span class="text-secondary mr-3 my-0.5">
                {{ item.dateFrom }}
            </span>
            <span class="mr-3 my-0.5">
                {{ item.timeFrom }}
            </span>
            <div 
                class="text-white whitespace-nowrap leading-[23px] px-2 my-1"
                :class="item.type == 'GovernmentPaidTime' ? 'bg-timeslot-govpaid' : 'bg-timeslot-paid rounded-[9px]'"
            >
                {{ item.typeDisplayName }}
            </div>
            <div class="grow min-w-[20px]"></div>

            <div @click="$emit('showEarlierTimeSlot')" v-if="earlierAppointmentAvailable" class="hidden lg:flex items-center mr-4 text-md text-[#d78e22] cursor-pointer">
                <InformationCircleIcon class="w-6 mr-1 shrink-0" />
                <p class="underline select-none">{{ $t('booking.EarlierAppointmentAvailable') }}</p>
            </div>
        </div>

        <div v-else class="flex flex-wrap py-2 overflow-hidden">
            <div class="mr-3">
                <span class="text-secondary">{{ item.specialistDegree }}</span>
                {{ item.displayName }}
            </div>

            <heart-button
                v-if="type == 'specialist'"
                :specialist-code="item.specialistCode"
                class="mr-3"
            />

            <div v-else-if="type == 'institution'" class="w-1"></div>

            <div v-if="secondaryText" class="text-secondary font-light">{{ secondaryText }}</div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import { InformationCircleIcon } from '@heroicons/vue/24/outline'
    import HeartButton from '@/components/booking/specialists/HeartButton.vue'
    import SpecialistImage from '@/components/booking/specialists/SpecialistImage.vue'

    const props = defineProps({
        item: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: null
        },
        earlierAppointmentAvailable: {
            type: Boolean,
            default: false,
        }
    })

    defineEmits(['back', 'showEarlierTimeSlot'])

    const secondaryText = computed(() => {
        if (props.type == 'institution') {
            return props.item.address

        } else if (props.type == 'specialist') {
            return props.item.specialityDisplayName
        }

        return null
    })

</script>
